import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as TogglesActions from './toggles.actions';
import * as TogglesSelectors from './toggles.selectors';

import { FeatureFlagToggleList, FeatureFlagToggles } from '../../interface/feature-flags.interface';

@Injectable({ providedIn: 'root' })
export class TogglesFacade {
  private readonly store = inject(Store);

  selectors: { [key: string]: Observable<boolean | undefined> } = {};

  toggles$ = this.store.pipe(select(TogglesSelectors.getToggles));

  flag(toggle: FeatureFlagToggles): Observable<boolean | undefined> {
    if (!Object.keys(this.selectors).includes(toggle)) {
      this.selectors = {
        ...this.selectors,
        [toggle]: this.store.pipe(select(TogglesSelectors.getToggle(toggle))),
      };
    }

    return this.selectors[toggle];
  }

  update(params: FeatureFlagToggleList) {
    this.store.dispatch(TogglesActions.updated(params));
  }
}
